var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',{attrs:{"title":"Paid Tariffs","apiData":_vm.filteredAll,"hiddenDatasets":_vm.hiddenDatasets},on:{"filtersChanged":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }